import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { flatMap as _flatMap } from 'lodash';

import { KydCustomerDataModel } from '../../../../core/store/programs/kyd-smartphone/models/kyd-smartphone-policy.model';

@Component({
  selector: 'ds-kyd-smartphone-enroll-all-modal',
  templateUrl: './kyd-smartphone-enroll-all-modal.component.html',
  styleUrls: ['./kyd-smartphone-enroll-all-modal.component.scss'],
  standalone: false
})
export class KydSmartphoneEnrollAllModalComponent implements OnInit {
  @Input() operatorsData: Dictionary<KydCustomerDataModel>;
  @Input() phoneNumbers: string[];

  @Output() enrollAll = new EventEmitter<Dictionary<KydCustomerDataModel>>();
  @Output() closeModal = new EventEmitter<string>();

  public modalId = 'multiple-operators';

  public requestEnrollmentPayload: Dictionary<KydCustomerDataModel> = {};
  public duplicatePhoneError = false;
  public allPhonesValid = false;

  constructor() {}

  ngOnInit(): void {}

  changeNumber(updatedPhoneNumber: string, operatorId: string) {
    const trimmedPhone = updatedPhoneNumber.replace(/-/g, '');
    this.operatorsData[operatorId].phoneNumber = trimmedPhone;
    this.operatorsData[operatorId].isPhoneValid = trimmedPhone.length === 10;
    this.duplicatePhoneError = this.isCurrentContextDuplicateNumberUsed();
    this.allPhonesValid = this.checkIfPhonesValid();
  }

  save() {
    this.requestEnrollmentPayload = this.operatorsData;
    this.enrollAll.emit(this.requestEnrollmentPayload);
  }
  /**
   *
   * @description: Check if the list of operator phone numbers contains duplicates.s
   */
  private isCurrentContextDuplicateNumberUsed(): boolean {
    const phones = _flatMap(
      Object.values(this.operatorsData),
      operator => operator.phoneNumber
    ).filter(phone => phone);

    return phones.some((item, index) => {
      return phones.indexOf(item) !== index;
    });
  }

  /**
   *
   * @description: Check if all phone numbers are valid length
   */
  private checkIfPhonesValid(): boolean {
    const phoneStatuses = _flatMap(
      Object.values(this.operatorsData),
      operator => operator.isPhoneValid
    );
    return !phoneStatuses.some(status => !status);
  }
}
